import React from 'react';
import { Card, CardContent } from '@lb-service/ui';
import Link from 'next/link';

const CourseListItem = ({ url, imageUrl, title, intro }) => {
  return (
    <Link href={url} className="block">
      <Card className="overflow-hidden hover:shadow-md">
        <img
          className="aspect-video w-full object-cover"
          alt={title}
          src={imageUrl}
        />
        <CardContent>
          <div className="course-list--title">
            <div className="link-blue">
              <h2 className="text-xl">{title}</h2>
            </div>
          </div>
          <div className="course-list--intro">
            <p>{intro}</p>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default CourseListItem;
